jQuery(document).on("page.ready", function () {
  $ = jQuery;

  if ($(".projects-single").length) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    /*****************************************************************
      Projects
    ******************************************************************/
    var projectSlider = $(".projects .owl-carousel");
    projectSlider
      .owlCarousel({
        autoplay: false,
        loop: false,
        nav: true,
        navContainer: ".prop-controls",
        navElement: "div",
        navText: ["", ""],
        items: 1,
        margin: 0,
        slideBy: 1,
        rewind: true,
        rewindNav: true,
        rewindSpeed: 0,
        dots: false,
        autoHeight: true,
        lazyLoad: true,
        checkVisibility: false,
        responsive: {
          768: {
            items: 3,
          },
          950: {
            items: 3,
          },
          1200: {
            items: 3,
          },
        },
        onInitialized: function (e) {
          var totalCount = $(projectSlider).parents(".container").find(".slide-num-contain .nums-total");
          var currentCount = $(projectSlider).parents(".container").find(".slide-num-contain .nums-count");
          // totalCount.text("0" + e.item.count);

          var spacerItemsReducer = 2;
          if (isMobile) {
            spacerItemsReducer = 0;
          }

          totalCount.text("0" + (e.item.count - spacerItemsReducer));

          currentCount.text("0" + (e.item.index + 1));
        },
      })
      .on("changed.owl.carousel", function (e) {
        var currentCount = $(projectSlider).parents(".container").find(".slide-num-contain .nums-count");
        currentCount.text("0" + (e.item.index + 1));
      });
    $(window).on("resize", function () {
      $(".projects .owl-carousel .owl-stage-outer").width(innerWidth);
    });

    /*****************************************************************
      Gallery Modal Slider Carousel
    ******************************************************************/
    var gallerySlider = $(".gallery-contain .gallery.owl-carousel");
    var thumbSlider = $(".gallery-contain .gallery-thumbnails.owl-carousel");

    var itemsToShow = 11;
    var itemCount;

    var owlNavBtns = [
      '<svg xmlns="http://www.w3.org/2000/svg" width="301.995" height="301.995" viewBox="0 0 301.995 301.995"><g id="Group_2075" data-name="Group 2075" transform="translate(1095.995 -1000) rotate(90)"><g id="Ellipse_1" data-name="Ellipse 1" transform="translate(1000 794)" fill="none" stroke="#fd6820" stroke-width="4"><circle cx="150.997" cy="150.997" r="150.997" stroke="none"/><circle cx="150.997" cy="150.997" r="148.997" fill="none"/></g><g id="Group_789" data-name="Group 789" transform="translate(1139.677 909.393)"><path id="Path_1427" data-name="Path 1427" d="M0,8.205,11.321,0,22.641,8.205" transform="translate(22.641 66.281) rotate(180)" fill="none" stroke="#fd6820" stroke-miterlimit="10" stroke-width="4"/><line id="Line_7" data-name="Line 7" y1="66.281" transform="translate(11.321 0)" fill="#fff" stroke="#fd6820" stroke-miterlimit="10" stroke-width="4"/></g></g></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="301.995" height="301.995" viewBox="0 0 301.995 301.995"><g id="Group_2075" data-name="Group 2075" transform="translate(1095.995 -1000) rotate(90)"><g id="Ellipse_1" data-name="Ellipse 1" transform="translate(1000 794)" fill="none" stroke="#fd6820" stroke-width="4"><circle cx="150.997" cy="150.997" r="150.997" stroke="none"/><circle cx="150.997" cy="150.997" r="148.997" fill="none"/></g><g id="Group_789" data-name="Group 789" transform="translate(1139.677 909.393)"><path id="Path_1427" data-name="Path 1427" d="M0,8.205,11.321,0,22.641,8.205" transform="translate(22.641 66.281) rotate(180)" fill="none" stroke="#fd6820" stroke-miterlimit="10" stroke-width="4"/><line id="Line_7" data-name="Line 7" y1="66.281" transform="translate(11.321 0)" fill="#fff" stroke="#fd6820" stroke-miterlimit="10" stroke-width="4"/></g></g></svg>',
    ];

    gallerySlider.owlCarousel({
      autoplay: false,
      // loop: true,
      loop: false,
      stagePadding: 0,
      nav: true,
      navSpeed: 600,
      rewind: true,
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47"><g id="Group_2467" data-name="Group 2467" transform="translate(46.789 47) rotate(180)"><g id="Group_796" data-name="Group 796" transform="translate(19.795 30.987) rotate(-90)"><path id="Path_1427" data-name="Path 1427" d="M0,7.536,7.755,0,15.51,7.536" transform="translate(15.51 7.536) rotate(180)" fill="none" stroke="#fdfbf4" stroke-miterlimit="10" stroke-width="1.5"/></g><g id="Ellipse_4" data-name="Ellipse 4" transform="translate(-0.211 0)" fill="none" stroke="#fd6820" stroke-width="1.5"><circle cx="23.5" cy="23.5" r="23.5" stroke="none"/><circle cx="23.5" cy="23.5" r="22.75" fill="none"/></g></g></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47"><g id="Group_2467" data-name="Group 2467" transform="translate(46.789 47) rotate(180)"><g id="Group_796" data-name="Group 796" transform="translate(19.795 30.987) rotate(-90)"><path id="Path_1427" data-name="Path 1427" d="M0,7.536,7.755,0,15.51,7.536" transform="translate(15.51 7.536) rotate(180)" fill="none" stroke="#fdfbf4" stroke-miterlimit="10" stroke-width="1.5"/></g><g id="Ellipse_4" data-name="Ellipse 4" transform="translate(-0.211 0)" fill="none" stroke="#fd6820" stroke-width="1.5"><circle cx="23.5" cy="23.5" r="23.5" stroke="none"/><circle cx="23.5" cy="23.5" r="22.75" fill="none"/></g></g></svg>',
      ],
      items: 1,
      margin: 0,
      slideBy: 1,
      dots: false,
      autoHeight: false,
      lazyLoad: true,
      checkVisibility: true,
      center: true,
      responsive: {
        0: {},
        950: {
          navText: owlNavBtns,
          stagePadding: 150,
        },
        1200: {
          navText: owlNavBtns,
          stagePadding: 200,
        },
        1500: {
          navText: owlNavBtns,
          stagePadding: 300,
        },
      },
    });

    gallerySlider.on("translate.owl.carousel", function (e) {
      // rounded down from items to show in thumbnail count "itemsToShow"
      // var magicNumber = Math.floor(e.item.count / 2);
      // var number = e.item.index + magicNumber;
      setTimeout(function () {
        // thumbSlider.data("owl.carousel").to(number, 300);
        thumbSlider.data("owl.carousel").to(e.item.index, 300);
      }, 0);
    });

    gallerySlider.on("changed.owl.carousel", function (e) {
      stopVideos();

      // Fixes Issue with Cloned Items and Last Item in Infinite Loop
      // console.log(e.item.count, e.item.index, Math.ceil(e.item.count / 2) - 1);

      // $(e.target).find(".owl-item").removeClass("active-visible");
      // var formulaForLast = Math.ceil(e.item.count / 2) - 1;
      // if (e.item.index === formulaForLast) {
      //   $(e.target)
      //     .find(".owl-item")
      //     .eq(e.item.index + e.item.count)
      //     .addClass("active-visible");
      // }
    });

    $(window).on("resize", function () {
      $(".gallery-contain .gallery.owl-carousel .owl-stage-outer").width(innerWidth);
    });

    // Thumbs
    thumbSlider
      .on("initialized.owl.carousel", function (e) {
        itemCount = e.item.count;
      })
      .owlCarousel({
        autoplay: false,
        // loop: false,
        rewind: true,
        loop: false,
        nav: false,
        items: itemsToShow,
        margin: 0,
        slideBy: 1,
        dots: true,
        autoHeight: false,
        lazyLoad: true,
        checkVisibility: true,
        center: true,
      });

    thumbSlider.on("translate.owl.carousel", function (e) {
      // var magicNumber = e.item.count - itemsToShow; // itemsToShow very important
      // var number = e.item.index + magicNumber;
      // if (e.item.count > itemsToShow * 2) {
      //   // Algorithm adjustment -     // 28 / 2 - 11
      //   var numAdjust = Math.ceil(e.item.count / 2 - itemsToShow);
      //   number = number - numAdjust;
      //   // Iteration Pattern
      //   // number = number - 1; // 23
      //   // number = number - 1; // 24
      //   // number = number - 2; // 25
      //   // number = number - 2; // 26
      //   // number = number - 3; // 27
      //   // number = number - 3; // 28
      //   // number = number - 4; // 29
      //   // number = number - 4; // 30
      //   // number = number - 5; // 31
      //   //  number = number - 5; // 32
      //   // number = number - 6; // 33
      //   // number = number - 6; // 34
      //   // number = number - 7; // 35
      //   // number = number - 7; // 36
      //   // number = number - 8; // 37
      // }
      // gallerySlider.data("owl.carousel").to(number, 0);
    });

    // thumbSlider.on("changed.owl.carousel", function (e) {
    //   var number = e.item.index;
    // });

    thumbSlider.on("click", ".owl-item", function (e) {
      e.preventDefault();
      var numb = $(this).index();

      // var magicNumber = itemCount - itemsToShow; // itemsToShow very important
      // var number = numb + magicNumber;
      // if (itemCount > itemsToShow * 2) {
      //   var numAdjust = Math.ceil(itemCount / 2 - itemsToShow);
      //   number = number - numAdjust;
      // }
      // gallerySlider.data("owl.carousel").to(number, 300);
      gallerySlider.data("owl.carousel").to(numb, 300);

      setTimeout(function () {
        // thumbSlider.data("owl.carousel").to(number, 300);
        thumbSlider.data("owl.carousel").to(numb, 300);
      }, 0);
    });

    var stopVideos = function () {
      var videos = document.querySelectorAll(".modal iframe, .modal video");
      Array.prototype.forEach.call(videos, function (video) {
        if (video.tagName.toLowerCase() === "video") {
          video.pause();
        } else {
          // var src = video.src;
          var newsrc = video.src.replace("?autoplay=1", "?autoplay=0");
          video.src = newsrc;
        }
      });
    };

    /*****************************************************************
       Testimonials Slider
    ******************************************************************/
    var quoteSlider = $(".project-testimonials .owl-carousel"),
      autoplayTimeoutSpeed = 8000;

    quoteSlider.owlCarousel({
      autoplay: true,
      autoplayTimeout: autoplayTimeoutSpeed,
      loop: false,
      nav: true,
      navContainer: ".slide-item-nav",
      navText: ["", ""],
      items: 1,
      margin: 0,
      slideBy: 1,
      rewind: true,
      rewindNav: true,
      rewindSpeed: 0,
      dots: false,
      autoHeight: false,
      lazyLoad: true,
      checkVisibility: false,
      mouseDrag: false,
      pullDrag: false,
      onInitialized: function (e) {
        var totalCount = $(quoteSlider).parents(".container").find(".slide-num-contain .nums-total");
        var currentCount = $(quoteSlider).parents(".container").find(".slide-num-contain .nums-count");
        totalCount.text("0" + e.item.count);
        currentCount.text("0" + (e.item.index + 1));

        if (e.item.count == 1) {
          console.log("only one");
          this.options.loop = false;
          this.options.nav = false;
          this.options.mouseDrag = false;
          $(".project-testimonials").addClass("solo-slide");
        } else {
          console.log("multiple");
          this.options.loop = true;
          this.options.nav = true;
          this.options.mouseDrag = true;
        }

        if (e.item.index === 0) {
          $(".slide-progress .progress-bar")
            .eq(e.item.index)
            .children(".progress")
            .css({
              width: "100%",
              transition: autoplayTimeoutSpeed - 250 + "ms",
            });
        }
      },
      onTranslate: function (e) {
        $(".slide-progress .progress-bar").each(function (index, el) {
          if (index < e.item.index) {
            $(el).children(".progress").css({
              width: "100%",
              transition: "none",
            });
          } else {
            $(el).children(".progress").css({
              width: "0%",
              transition: "none",
            });
          }
        });
      },
      onTranslated: function (e) {
        $(".slide-progress .progress-bar").each(function (index, el) {
          if (index < e.item.index) {
            $(el).children(".progress").css({
              width: "100%",
              transition: "none",
            });
          }

          if (index === e.item.index) {
            $(el)
              .children(".progress")
              .css({
                width: "100%",
                transition: autoplayTimeoutSpeed - 250 + "ms",
              });
          }

          if (index > e.item.index) {
            $(el).children(".progress").css({
              width: "0%",
              transition: "none",
            });
          }
        });
      },
    });

    quoteSlider.on("changed.owl.carousel", function (e) {
      var currentCount = $(quoteSlider).parents(".container").find(".slide-num-contain .nums-count");
      currentCount.text("0" + (e.item.index + 1));
      quoteSlider.trigger("stop.owl.autoplay");
      quoteSlider.trigger("play.owl.autoplay", [autoplayTimeoutSpeed, 250]);

      var bgImages = $(".project-testimonials .background-images"),
        bgImagesInner = $(".project-testimonials .background-images .bg-contain");
      bgImages.children().each(function (index, el) {
        bgImagesInner.removeClass("active");
        bgImagesInner.eq(e.item.index).addClass("active");
      });
    });

    $(window).on("resize", function () {
      $(".project-testimonials .owl-carousel .owl-stage-outer").width(innerWidth);
    });

    // Stop Carousel on Modal popup
    $(".testimonials-carousel .play-btn").click(function () {
      quoteSlider.trigger("stop.owl.autoplay");
    });

    // Play Carousel on CLose of modal
    $(".modal .close-modal").click(function () {
      quoteSlider.trigger("play.owl.autoplay", [autoplayTimeoutSpeed, 250]);
    });

    /*****************************************************************
     * Cursor Manipulation for Slider
     *****************************************************************/
    var cursor = $(".cursor");
    $(window).mousemove(function (e) {
      cursor.css({
        top: e.clientY - cursor.height() / 2,
        left: e.clientX - cursor.width() / 2,
      });
    });

    $(".project-testimonials")
      .mouseleave(function () {
        cursor.css({
          opacity: "0",
        });
      })
      .mouseenter(function () {
        cursor.css({
          opacity: "1",
        });
      });

    $(".project-testimonials .owl-prev")
      .mouseenter(function () {
        cursor.css({
          transform: "scale(-1)",
        });
      })
      .mouseleave(function () {
        cursor.css({
          transform: "scale(1)",
        });
      });

    $(".project-testimonials .play-btn")
      .mouseenter(function () {
        cursor.css({
          opacity: "0",
        });
      })
      .mouseleave(function () {
        cursor.css({
          opacity: "1",
        });
      });
  }
});
